import { render, staticRenderFns } from "./MailAddressSetup.vue?vue&type=template&id=4baa0d89&scoped=true&"
import script from "./MailAddressSetup.vue?vue&type=script&lang=ts&"
export * from "./MailAddressSetup.vue?vue&type=script&lang=ts&"
import style0 from "./MailAddressSetup.vue?vue&type=style&index=0&id=4baa0d89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baa0d89",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VSheet,VTextField})
